import { z } from 'zod';
import { storedHttpUrlSchema } from '../safe-url.js';

export const manufacturerItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  countryCode: z.string().nullable(),
  website: z.string().nullable(),
  displayOrder: z.number(),
  isActive: z.boolean(),
  oemBuybackProgramName: z.string().nullable(),
  defaultDataSourceId: z.string().nullable(),
  metadata: z.unknown().nullable(),
});
export type ManufacturerItem = z.infer<typeof manufacturerItemSchema>;

export const manufacturerListResponseSchema = z.object({
  data: z.array(manufacturerItemSchema),
});
export type ManufacturerListResponse = z.infer<typeof manufacturerListResponseSchema>;

export const manufacturerDetailResponseSchema = z.object({
  data: manufacturerItemSchema,
});
export type ManufacturerDetailResponse = z.infer<typeof manufacturerDetailResponseSchema>;

export const createManufacturerBodySchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().optional(),
  countryCode: z.string().length(2).optional(),
  website: storedHttpUrlSchema.optional(),
  displayOrder: z.number().int().optional(),
  oemBuybackProgramName: z.string().optional(),
  defaultDataSourceId: z.string().optional(),
  metadata: z.record(z.unknown()).optional(),
});
export type CreateManufacturerBody = z.infer<typeof createManufacturerBodySchema>;

export const updateManufacturerBodySchema = z.object({
  name: z.string().min(1).max(120).optional(),
  description: z.string().nullable().optional(),
  countryCode: z.string().length(2).nullable().optional(),
  website: storedHttpUrlSchema.nullable().optional(),
  displayOrder: z.number().int().optional(),
  isActive: z.boolean().optional(),
  oemBuybackProgramName: z.string().nullable().optional(),
  defaultDataSourceId: z.string().nullable().optional(),
  metadata: z.record(z.unknown()).nullable().optional(),
});
export type UpdateManufacturerBody = z.infer<typeof updateManufacturerBodySchema>;
